<template>
  <div>
    <plex-header></plex-header>
    <router-view></router-view>
    <plex-footer></plex-footer>
  </div>
</template>

<script>
  import PlexHeader from '../../components/plexHeader/mainHeader/Index.vue'
  import PlexFooter from '../../components/footer/Footer.vue'

  export default {
    name: 'normal-page',
    components: {PlexHeader, PlexFooter}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// NormalPage.vue?177bf52e